import React from 'react';
import { Nav } from '../components/Nav/Nav';
import { PageLoader } from '../components/PageLoader';
import { Blog } from '../components/sections/Blog';
import { Brands } from '../components/sections/Brands';
import { Faq } from '../components/sections/Faq';
import { Footer } from '../components/sections/Footer';
import { Hero } from '../components/sections/Hero';
import { Projects } from '../components/sections/Projects';
import { Services } from '../components/sections/Services';
import { Showreel } from '../components/sections/Showreel';
export function Home() {
  return <div className="relative w-full overflow-x-clip bg-white" data-id="element-203" data-mp="29g4xslatoow3">
      <PageLoader data-id="element-204" data-mp="29ek6d4jt1m2g" />
      <Nav data-id="element-205" data-mp="29i7vlri7vmbd" />
      <main data-id="element-206" data-mp="2dhqhoqlry3fs">
        <Hero data-id="element-207" data-mp="2dhgo6t1ite5c" />
        <Brands data-id="element-208" data-mp="2dhyvckpq1cs1" />
        <Showreel data-id="element-209" data-mp="2dii1l460ecq8" />
        <Services data-id="element-210" data-mp="2dj1o6y6ltpal" />
        <Projects data-id="element-211" data-mp="2dfdthvpfawua" />
        <Blog data-id="element-212" data-mp="3kvk3qel0er3c" />
        <Faq data-id="element-213" data-mp="3kw1xn4k78t83" />
      </main>
      <Footer data-id="element-214" data-mp="3kuqv182hprik" />
    </div>;
}